const auth = {
  en: {
    'auth.login.title': 'Sign in to your account',
    'auth.login.or': 'Or',
    'auth.login.createAccount': 'create a new account',
    'auth.login.usernameLabel': 'Username or Email',
    'auth.login.usernameRequired': 'Username or email is required',
    'auth.login.usernamePlaceholder': 'Enter your username or email',
    'auth.login.passwordLabel': 'Password',
    'auth.login.passwordRequired': 'Password is required',
    'auth.login.passwordPlaceholder': 'Enter your password',
    'auth.login.rememberMe': 'Remember me',
    'auth.login.forgotPassword': 'Forgot your password?',
    'auth.login.submit': 'Sign in',

    'auth.register.title': 'Create your account',
    'auth.register.or': 'Or',
    'auth.register.signIn': 'sign in to your existing account',
    'auth.register.firstNameLabel': 'First Name',
    'auth.register.firstNameRequired': 'First name is required',
    'auth.register.firstNameMin': 'First name must be at least 2 characters',
    'auth.register.firstNamePlaceholder': 'First name',
    'auth.register.lastNameLabel': 'Last Name',
    'auth.register.lastNameRequired': 'Last name is required',
    'auth.register.lastNameMin': 'Last name must be at least 2 characters',
    'auth.register.lastNamePlaceholder': 'Last name',
    'auth.register.usernameLabel': 'Username',
    'auth.register.usernameRequired': 'Username is required',
    'auth.register.usernameMin': 'Username must be at least 3 characters',
    'auth.register.usernamePattern': 'Username can only contain letters, numbers, and underscores',
    'auth.register.usernamePlaceholder': 'Choose a username',
    'auth.register.emailLabel': 'Email Address',
    'auth.register.emailRequired': 'Email is required',
    'auth.register.emailInvalid': 'Please enter a valid email address',
    'auth.register.emailPlaceholder': 'Enter your email',
    'auth.register.roleLabel': 'I am a',
    'auth.register.roleRequired': 'Role is required',
    'auth.register.roleSelect': 'Select a role',
    'auth.register.roleEmployee': 'Employee',
    'auth.register.roleContractor': 'Contractor (individual)',
    'auth.register.roleManager': 'Manager',
    'auth.register.roleAdmin': 'Administrator',
    'auth.register.hourlyRateLabel': 'Hourly Rate (Optional)',
    'auth.register.hourlyRateMin': 'Hourly rate must be positive',
    'auth.register.passwordLabel': 'Password',
    'auth.register.passwordRequired': 'Password is required',
    'auth.register.passwordMin': 'Password must be at least 8 characters',
    'auth.register.passwordPlaceholder': 'Create a password',
    'auth.register.confirmLabel': 'Confirm Password',
    'auth.register.confirmRequired': 'Please confirm your password',
    'auth.register.passwordMismatch': 'Passwords do not match',
    'auth.register.confirmPlaceholder': 'Confirm your password',
    'auth.register.submit': 'Create Account',

    'auth.profile.title': 'Profile Settings',
    'auth.profile.subtitle': 'Manage your account settings and preferences',
    'auth.profile.tabProfile': 'Profile Information',
    'auth.profile.tabPassword': 'Change Password',
    'auth.profile.infoHeading': 'Profile Information',
    'auth.profile.infoDescription': 'Update your personal information and account details.',
    'auth.profile.firstNameLabel': 'First Name',
    'auth.profile.firstNameRequired': 'First name is required',
    'auth.profile.firstNameMin': 'First name must be at least 2 characters',
    'auth.profile.lastNameLabel': 'Last Name',
    'auth.profile.lastNameRequired': 'Last name is required',
    'auth.profile.lastNameMin': 'Last name must be at least 2 characters',
    'auth.profile.emailLabel': 'Email Address',
    'auth.profile.emailRequired': 'Email is required',
    'auth.profile.emailInvalid': 'Please enter a valid email address',
    'auth.profile.phoneLabel': 'Phone Number',
    'auth.profile.phonePlaceholder': 'Optional',
    'auth.profile.hourlyRateLabel': 'Hourly Rate',
    'auth.profile.hourlyRateMin': 'Hourly rate must be positive',
    'auth.profile.save': 'Save Changes',
    'auth.profile.changePasswordHeading': 'Change Password',
    'auth.profile.changePasswordDescription': 'Update your password to keep your account secure.',
    'auth.profile.currentPasswordLabel': 'Current Password',
    'auth.profile.currentPasswordRequired': 'Current password is required',
    'auth.profile.newPasswordLabel': 'New Password',
    'auth.profile.newPasswordRequired': 'New password is required',
    'auth.profile.newPasswordMin': 'Password must be at least 6 characters',
    'auth.profile.confirmNewPasswordLabel': 'Confirm New Password',
    'auth.profile.confirmNewPasswordRequired': 'Please confirm your new password',
    'auth.profile.passwordMismatch': 'Passwords do not match',
    'auth.profile.changePassword': 'Change Password',
  },

  es: {
    'auth.login.title': 'Inicia sesión en tu cuenta',
    'auth.login.or': 'O',
    'auth.login.createAccount': 'crea una cuenta nueva',
    'auth.login.usernameLabel': 'Usuario o correo electrónico',
    'auth.login.usernameRequired': 'El usuario o correo electrónico es obligatorio',
    'auth.login.usernamePlaceholder': 'Ingresa tu usuario o correo electrónico',
    'auth.login.passwordLabel': 'Contraseña',
    'auth.login.passwordRequired': 'La contraseña es obligatoria',
    'auth.login.passwordPlaceholder': 'Ingresa tu contraseña',
    'auth.login.rememberMe': 'Recordarme',
    'auth.login.forgotPassword': '¿Olvidaste tu contraseña?',
    'auth.login.submit': 'Iniciar sesión',

    'auth.register.title': 'Crea tu cuenta',
    'auth.register.or': 'O',
    'auth.register.signIn': 'inicia sesión en tu cuenta existente',
    'auth.register.firstNameLabel': 'Nombre',
    'auth.register.firstNameRequired': 'El nombre es obligatorio',
    'auth.register.firstNameMin': 'El nombre debe tener al menos 2 caracteres',
    'auth.register.firstNamePlaceholder': 'Nombre',
    'auth.register.lastNameLabel': 'Apellido',
    'auth.register.lastNameRequired': 'El apellido es obligatorio',
    'auth.register.lastNameMin': 'El apellido debe tener al menos 2 caracteres',
    'auth.register.lastNamePlaceholder': 'Apellido',
    'auth.register.usernameLabel': 'Usuario',
    'auth.register.usernameRequired': 'El usuario es obligatorio',
    'auth.register.usernameMin': 'El usuario debe tener al menos 3 caracteres',
    'auth.register.usernamePattern': 'El usuario solo puede contener letras, números y guiones bajos',
    'auth.register.usernamePlaceholder': 'Elige un usuario',
    'auth.register.emailLabel': 'Correo electrónico',
    'auth.register.emailRequired': 'El correo electrónico es obligatorio',
    'auth.register.emailInvalid': 'Ingresa una dirección de correo electrónico válida',
    'auth.register.emailPlaceholder': 'Ingresa tu correo electrónico',
    'auth.register.roleLabel': 'Soy',
    'auth.register.roleRequired': 'El rol es obligatorio',
    'auth.register.roleSelect': 'Selecciona un rol',
    'auth.register.roleEmployee': 'Empleado',
    'auth.register.roleContractor': 'Contratista (individual)',
    'auth.register.roleManager': 'Gerente',
    'auth.register.roleAdmin': 'Administrador',
    'auth.register.hourlyRateLabel': 'Tarifa por hora (opcional)',
    'auth.register.hourlyRateMin': 'La tarifa por hora debe ser positiva',
    'auth.register.passwordLabel': 'Contraseña',
    'auth.register.passwordRequired': 'La contraseña es obligatoria',
    'auth.register.passwordMin': 'La contraseña debe tener al menos 8 caracteres',
    'auth.register.passwordPlaceholder': 'Crea una contraseña',
    'auth.register.confirmLabel': 'Confirmar contraseña',
    'auth.register.confirmRequired': 'Confirma tu contraseña',
    'auth.register.passwordMismatch': 'Las contraseñas no coinciden',
    'auth.register.confirmPlaceholder': 'Confirma tu contraseña',
    'auth.register.submit': 'Crear cuenta',

    'auth.profile.title': 'Configuración del perfil',
    'auth.profile.subtitle': 'Administra la configuración y las preferencias de tu cuenta',
    'auth.profile.tabProfile': 'Información del perfil',
    'auth.profile.tabPassword': 'Cambiar contraseña',
    'auth.profile.infoHeading': 'Información del perfil',
    'auth.profile.infoDescription': 'Actualiza tu información personal y los datos de tu cuenta.',
    'auth.profile.firstNameLabel': 'Nombre',
    'auth.profile.firstNameRequired': 'El nombre es obligatorio',
    'auth.profile.firstNameMin': 'El nombre debe tener al menos 2 caracteres',
    'auth.profile.lastNameLabel': 'Apellido',
    'auth.profile.lastNameRequired': 'El apellido es obligatorio',
    'auth.profile.lastNameMin': 'El apellido debe tener al menos 2 caracteres',
    'auth.profile.emailLabel': 'Correo electrónico',
    'auth.profile.emailRequired': 'El correo electrónico es obligatorio',
    'auth.profile.emailInvalid': 'Ingresa una dirección de correo electrónico válida',
    'auth.profile.phoneLabel': 'Número de teléfono',
    'auth.profile.phonePlaceholder': 'Opcional',
    'auth.profile.hourlyRateLabel': 'Tarifa por hora',
    'auth.profile.hourlyRateMin': 'La tarifa por hora debe ser positiva',
    'auth.profile.save': 'Guardar cambios',
    'auth.profile.changePasswordHeading': 'Cambiar contraseña',
    'auth.profile.changePasswordDescription': 'Actualiza tu contraseña para mantener tu cuenta segura.',
    'auth.profile.currentPasswordLabel': 'Contraseña actual',
    'auth.profile.currentPasswordRequired': 'La contraseña actual es obligatoria',
    'auth.profile.newPasswordLabel': 'Nueva contraseña',
    'auth.profile.newPasswordRequired': 'La nueva contraseña es obligatoria',
    'auth.profile.newPasswordMin': 'La contraseña debe tener al menos 6 caracteres',
    'auth.profile.confirmNewPasswordLabel': 'Confirmar nueva contraseña',
    'auth.profile.confirmNewPasswordRequired': 'Confirma tu nueva contraseña',
    'auth.profile.passwordMismatch': 'Las contraseñas no coinciden',
    'auth.profile.changePassword': 'Cambiar contraseña',
  },
};

export default auth;
